export const SERVICE_OPTIONS = [
  { value: 'casas', label: 'Casas', icon: '🏠', description: 'Compra, financiamento e consultoria' },
  { value: 'reforma', label: 'Reforma', icon: '🛠️', description: 'Melhorias internas e externas' },
  { value: 'painel_solar', label: 'Painel Solar', icon: '☀️', description: 'Energia solar para residência/comércio' },
];

export const CONSULTATION_OPTIONS = [
  { value: 'comprar-casa', label: 'Quero comprar casa' },
  { value: 'financiamento', label: 'Dúvidas sobre financiamento' },
  { value: 'credito', label: 'Dúvidas sobre nome limpo / crédito' },
  { value: 'reforma', label: 'Quero fazer reforma' },
  { value: 'solar', label: 'Quero instalar painel solar' },
  { value: 'outros', label: 'Outras informações' },
];

export const WORK_OPTIONS = [
  { value: 'seishain', label: 'Sei-shain / Keiyaku-shain' },
  { value: 'haken', label: 'Haken-shain' },
  { value: 'part', label: 'Part / Arubaito' },
  { value: 'independente', label: 'Negócio independente' },
  { value: 'sem-trabalho', label: 'Não estou trabalhando' },
];

export const SOCIAL_ITEMS = [
  'Visto Permanente',
  'Nacionalidade Japonesa',
  'Shakai Hoken',
  'Kokumin Hoken',
  'Nenhum dos itens acima',
];

export const TIME_OPTIONS = [
  '10:00 ~ 11:00',
  '11:00 ~ 12:00',
  '12:00 ~ 13:00',
  '13:00 ~ 14:00',
  '14:00 ~ 15:00',
  '15:00 ~ 16:00',
  '16:00 ~ 17:00',
  '17:00 ~ 18:00',
  '18:00 ~ 19:00',
];

export const INITIAL_FORM_DATA = {
  name: '',
  email: '',
  phone: '',
  homePhone: '',
  ageRange: '',
  gender: '',
  address: '',
  bestContactTime: '',
  serviceCategory: '',
  consultationType: '',
  hasOtherRealEstateConsultation: '',
  workType: '',
  socialItems: [],
  attendancePreference: '',
  propertyGoal: '',
  preferredArea: '',
  budgetRange: '',
  financingStatus: '',
  reformType: '',
  reformPropertyType: '',
  reformTimeline: '',
  solarPropertyType: '',
  monthlyEnergyBill: '',
  solarGoal: '',
  hasBatteryInterest: '',
  firstPreferredDate: '',
  firstPreferredTime: '',
  secondPreferredDate: '',
  secondPreferredTime: '',
  notes: '',
  privacyAccepted: false,
};
